<template>
  <div class="user">
    <div class="apply">
      <div class="apply_head">
        <span class="title">我的申请记录</span>

        <ghidri-back />
      </div>

      <div class="apply_content" v-if="orderLength > 0">
        <el-card v-for="item in campusOrderList" :key="item.id" :body-style="{ padding: '0' }">
          <div slot="header">
            <el-tag class="apply_content_category" type="success">校园招聘</el-tag>
            <span class="apply_content_applyTime">申请时间：{{ item.applyTime | formatDate(true) }}</span>
            <el-tag class="apply_content_status" :type="item.status | statusFilter">{{ item.statusName }}</el-tag>
          </div>
          <campus-order-item :item="item" @ok="toCampusOrgnDetail"></campus-order-item>
        </el-card>

        <el-card v-for="item in societyOrderList" :key="item.id" :body-style="{ padding: '0' }">
          <div slot="header">
            <el-tag class="apply_content_category" type="warning">社会招聘</el-tag>
            <span class="apply_content_applyTime">申请时间：{{ item.applyTime | formatDate(true) }}</span>
            <el-tag class="apply_content_status" :type="item.status | statusFilter">{{ item.statusName }}</el-tag>
          </div>
          <society-order-item :item="item" @ok="toSocietyOrgnDetail"></society-order-item>
        </el-card>

        <el-card v-for="item in summerOrderList" :key="item.id" :body-style="{ padding: '0' }" shadow="never">
          <div slot="header">
            <el-tag type="info" class="apply_content_category">夏令营招募</el-tag>
            <span class="apply_content_applyTime">申请时间：{{ item.applyTime | formatDate(true) }}</span>
            <el-tag class="apply_content_status" :type="item.status | statusFilter">{{ item.statusName }}</el-tag>
          </div>
          <summer-order-item :category-time-name="item.categoryTimeName"></summer-order-item>
        </el-card>

        <el-card v-for="item in traineeOrderList" :key="item.id" :body-style="{ padding: '0' }" shadow="never">
          <div slot="header">
            <el-tag class="apply_content_category" type="danger">实习生计划</el-tag>
            <span class="apply_content_applyTime">申请时间：{{ item.applyTime | formatDate(true) }}</span>
            <el-tag class="apply_content_status" :type="item.status | statusFilter">{{ item.statusName }}</el-tag>
          </div>
          <trainee-order-item :item="item" @ok="toTraineeOrgnDetail"></trainee-order-item>
        </el-card>

        <el-card v-for="item in doctorOrderList" :key="item.id" :body-style="{ padding: '0' }" shadow="never">
          <div slot="header">
            <el-tag class="apply_content_category" type="primary">博士后科研工作站</el-tag>
            <span class="apply_content_applyTime">申请时间：{{ item.applyTime | formatDate(true) }}</span>
            <el-tag class="apply_content_status" :type="item.status | statusFilter">{{ item.statusName }}</el-tag>
          </div>
          <doctor-order-item :item="item"></doctor-order-item>
        </el-card>
      </div>

      <div class="no-data" v-else>
        <ghidri-empty>暂无申请记录</ghidri-empty>
        <div class="no-data-btn">
          <el-button type="primary" block icon="el-icon-top-left" plain round size="large" @click="toHome">去申请</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import commonOrderApi from "@/api/commonOrder.js";

  import CampusOrderItem from "./item/campus-order-item.vue";
  import SocietyOrderItem from "./item/society-order-item.vue";
  import SummerOrderItem from "./item/summer-order-item.vue";
  import TraineeOrderItem from "./item/trainee-order-item.vue";
  import DoctorOrderItem from "./item/doctor-order-item.vue";

  export default {
    name: "Apply",
    components: {
      CampusOrderItem,
      SocietyOrderItem,
      SummerOrderItem,
      TraineeOrderItem,
      DoctorOrderItem
    },
    data() {
      return {
        traineeOrderList: [],
        summerOrderList: [],
        campusOrderList: [],
        societyOrderList: [],
        doctorOrderList: [],

        orderLength: 0
      };
    },
    created() {
      this.init();
    },
    filters: {
      statusFilter(status) {
        const statusMap = {
          'pending': 'info'
        }
        return statusMap[status]
      },
    },
    methods: {
      init() {
        const _this = this;
        let loading = _this.$loading({ position: { top: 60 } });
        commonOrderApi.getOrders().then(res => {
          if (!res.success) {
            _this.$message.error("网络出错，请稍后再试");
            return false;
          }

          const orderList = res.data; //申请列表

          _this.campusOrderList = orderList['campusOrders'];
          _this.societyOrderList = orderList['societyOrders'];
          _this.traineeOrderList = orderList['traineeOrders'];
          _this.summerOrderList = orderList['summerOrders'];
          _this.doctorOrderList = orderList['doctorOrders'];

          _this.orderLength = _this.campusOrderList.length + _this.societyOrderList.length + _this.traineeOrderList.length + _this.summerOrderList.length + _this.doctorOrderList.length

          loading.close();
        }).catch((err) => {
          console.log("err", err);
          loading.close();
          _this.$message.error(err || "网络出错，请稍后再试");
        });
      },

      toHome() {
        this.$router.push("/");
      },

      toCampusOrgnDetail(item) {
        this.$router.push({path: '/campus/orgn/' + item.orgnId})
      },
      toSocietyOrgnDetail(item) {
        this.$router.push({path: '/society/orgn/' + item.orgnId})
      },
      toTraineeOrgnDetail(item) {
        this.$router.push({path: '/trainee/orgn/' + item.orgnId})
      },

      backEvent() {
        this.$router.go(-1);
      }
    }
  };
</script>

<style lang="less">
  .el-card__header {
    padding: 10px 20px;
  }
</style>
<style scoped lang="less">
  .user {
    min-height: calc(100vh - 400px);
    display: flex;
    justify-content: center;
    padding: 20px 0;
  }

  .apply {
    width: 900px;

    &_head {
      margin-bottom: 20px;

      .title {
        padding-bottom: 8px;
        font-weight: 700;
        font-size: 22px;
        border-bottom: 2px solid #3370ff;
        color: #3370ff;
        line-height: 100%;
      }
    }

    &_content {

      &_category {
        margin-right: 10px;
      }

      &_applyTime {
        height: 32px;
        line-height: 30px
      }

      &_status {
        float: right;
      }

    }
  }

  .empty-icon {
    text-align: center;
    zoom: 300%;
  }

</style>
